import Statusbar from './Statusbar';

export default Statusbar;
